import type React from 'react'

import { PaymentSkeleton } from '../PaymentSkeleton'
import css from './styles.module.css'

export const PaymentsSkeleton: React.FC = () => {
  return (
    <div className={css.payments_skeleton}>
      <div className={css.header} data-skeleton-animation />
      <div className={css.list}>
        <PaymentSkeleton />
        <hr className={css.divider} />
        <PaymentSkeleton />
        <hr className={css.divider} />
        <PaymentSkeleton />
      </div>
    </div>
  )
}
